'use client';

import { c as _c } from "react/compiler-runtime";
import AssignmentIcon from '@mui/icons-material/Assignment';
import People from '@mui/icons-material/People';
import LibraryBooks from '@mui/icons-material/LibraryBooks';
import PresentToAll from '@mui/icons-material/PresentToAll';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
import CamilleSrc from '../IntroTestimonials/images/Camille.png';
import HafidSrc from '../IntroTestimonials/images/Hafid.png';
import AliceSrc from '../IntroTestimonials/images/Alice.png';
import ManonSrc from '../IntroTestimonials/images/Manon.png';
import Intro from './Intro';
import Quote from './Quote';
const Block = styled('div')(({
  theme: {
    palette,
    spacing,
    breakpoints
  }
}) => ({
  '&::before': {
    content: '""',
    position: 'relative',
    display: 'block',
    width: 2,
    backgroundColor: palette.brand.primary,
    margin: spacing(3, 'auto'),
    height: 60,
    [breakpoints.up('sm')]: {
      margin: spacing(1, 0, 1, 2),
      height: 120
    }
  },
  '&:first-of-type::before': {
    backgroundColor: 'transparent',
    backgroundImage: `linear-gradient(${palette.brand.primary} 33%, transparent 0%)`,
    backgroundPosition: 'right',
    backgroundSize: '4px 8px',
    backgroundRepeat: 'repeat-y'
  }
}));
const ServiceBlock = () => {
  const $ = _c(16);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = translate("student_experience.stepper_four.projects.keyword");
    t1 = translate("student_experience.stepper_four.projects.text");
    t2 = translate("student_experience.stepper_four.projects.quote");
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      id: "projects",
      icon: AssignmentIcon,
      title: t0,
      content: t1,
      quote: t2,
      pictureUrl: CamilleSrc,
      description: translate("student_experience.stepper_four.projects.quote_description"),
      status: translate("student_experience.stepper_four.projects.quote_description2")
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = translate("student_experience.stepper_four.mentor.keyword");
    t5 = translate("student_experience.stepper_four.mentor.text");
    t6 = translate("student_experience.stepper_four.mentor.quote");
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      id: "mentoring",
      icon: People,
      title: t4,
      content: t5,
      quote: t6,
      pictureUrl: HafidSrc,
      description: translate("student_experience.stepper_four.mentor.quote_description"),
      status: translate("student_experience.stepper_four.mentor.quote_description2")
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t10;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = translate("student_experience.stepper_four.resources.keyword");
    t9 = translate("student_experience.stepper_four.resources.text");
    t10 = translate("student_experience.stepper_four.resources.quote");
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      id: "resources",
      icon: LibraryBooks,
      title: t8,
      content: t9,
      quote: t10,
      pictureUrl: AliceSrc,
      description: translate("student_experience.stepper_four.resources.quote_description"),
      status: translate("student_experience.stepper_four.resources.quote_description2")
    };
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  let t13;
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = translate("student_experience.stepper_four.skill_assessment.keyword");
    t13 = translate("student_experience.stepper_four.skill_assessment.text");
    t14 = translate("student_experience.stepper_four.skill_assessment.quote");
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
  } else {
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    const INFORMATIONS = [t3, t7, t11, {
      id: "assessment",
      icon: PresentToAll,
      title: t12,
      content: t13,
      quote: t14,
      pictureUrl: ManonSrc,
      description: translate("student_experience.stepper_four.skill_assessment.quote_description"),
      status: translate("student_experience.stepper_four.skill_assessment.quote_description2")
    }];
    t15 = <div>{INFORMATIONS.map(_temp)}</div>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  return t15;
};
export default ServiceBlock;
function _temp(information) {
  return <Block key={information.id}><Intro title={information.title} intro={information.content} icon={information.icon} /><Quote variant="service" quote={information.quote} testimonialPictureSrc={information.pictureUrl} description={information.description} status={information.status} /></Block>;
}